import { render, staticRenderFns } from "./adicionarVenda.vue?vue&type=template&id=237aedb0"
import script from "./adicionarVenda.ts?vue&type=script&lang=js&external"
export * from "./adicionarVenda.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237aedb0')) {
      api.createRecord('237aedb0', component.options)
    } else {
      api.reload('237aedb0', component.options)
    }
    module.hot.accept("./adicionarVenda.vue?vue&type=template&id=237aedb0", function () {
      api.rerender('237aedb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfse/adicionarVenda.vue"
export default component.exports